import { render, staticRenderFns } from "./doge.vue?vue&type=template&id=208f22cb&"
import script from "./doge.vue?vue&type=script&lang=js&"
export * from "./doge.vue?vue&type=script&lang=js&"
import style0 from "./doge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports